import { CANONICAL_STORE_HOST } from './storefrontHost';

export { CANONICAL_STORE_HOST, resolveStorefrontHostHeader } from './storefrontHost';

/**
 * Same hosted API default as shop/client (`client/src/config/apiBaseUrl.js`).
 * Override with `REACT_APP_API_URL`. Must include `/api/v1`; no trailing slash.
 */
export const DEFAULT_API_BASE_URL = 'https://trendyshop-three.vercel.app/api/v1';

const DISALLOWED_LOCALHOST = /localhost|127\.0\.0\.1/i;

/**
 * Default tenant hostname (`Store.domains`) for messaging and fallbacks.
 * For the actual **`X-Store-Host`** header in the browser, use `resolveStorefrontHostHeader()`.
 */
export const STORE_HOST = CANONICAL_STORE_HOST;

/**
 * CRA base URL including `/api/v1`. No trailing slash.
 */
export function getApiBaseUrl() {
  const fromEnv = (process.env.REACT_APP_API_URL || '').trim();
  if (fromEnv) {
    const cleaned = fromEnv.replace(/\/$/, '');
    if (process.env.NODE_ENV === 'production' && DISALLOWED_LOCALHOST.test(cleaned)) {
      return DEFAULT_API_BASE_URL;
    }
    return cleaned;
  }
  return DEFAULT_API_BASE_URL;
}

/** @param {unknown} raw */
function parseEnvBoolFlag(raw, defaultWhenUnset) {
  if (raw === undefined || raw === null || String(raw).trim() === '') {
    return defaultWhenUnset;
  }
  const t = String(raw).trim().replace(/^["']|["']$/g, '').toLowerCase();
  if (['false', '0', 'no', 'off'].includes(t)) return false;
  if (['true', '1', 'yes', 'on'].includes(t)) return true;
  return defaultWhenUnset;
}

/**
 * Storefront reads catalog/settings/reviews/auth from the API. Matches maison/client `isApiEnabled` intent:
 *
 * - `REACT_APP_USE_API` omitted → enabled when there is an API base URL (default counts).
 * - `REACT_APP_USE_API=false` / `off` / `0` → disabled (static `products.js` on PLP where applicable).
 *
 * Parsing is trimming + case-insensitive so `"False"` reliably opts out — unlike fragile `=== 'false'` checks.
 */
export function isApiEnabled() {
  const baseConfigured = Boolean((getApiBaseUrl() || '').trim());
  return parseEnvBoolFlag(process.env.REACT_APP_USE_API, baseConfigured);
}

/** @deprecated prefer `isApiEnabled()` naming; retained for widespread imports */
export const USE_API = isApiEnabled();
